import React, { useState } from "react";
import { Select } from "@jsq/ds/core";
import { useFaUsers } from "../../hooks/useFaUsers";

interface AssignToPickerProps {
  arenaId: number;
  disabled?: boolean;
  onClaimSelf: () => void;
  onReassign: (userId: string, displayName: string) => void;
}

const ME_VALUE = "__me__";

export const AssignToPicker: React.FC<AssignToPickerProps> = ({
  arenaId,
  disabled = false,
  onClaimSelf,
  onReassign,
}) => {
  const { users, loading, error } = useFaUsers(arenaId);
  const [value, setValue] = useState<string>("");
  const placeholder = error
    ? "Failed to load users"
    : loading
      ? "Loading users…"
      : "Assign to…";

  return (
    <Select
      value={value}
      onChange={(raw) => {
        const v = String(raw);
        setValue("");
        if (v === ME_VALUE) {
          onClaimSelf();
          return;
        }
        const user = users.find((u) => u.id === v);
        if (user) onReassign(user.id, user.displayName);
      }}
      disabled={disabled}
      label="Assign to"
      hideLabel
      placeholder={placeholder}
      // Picker lives in the sticky ActionBar footer — mirror CheckerActionBar
      // and open upward so the menu is not clipped by the viewport bottom.
      position="up"
      matchFromStart={false}
      data-testid="action-bar-assign-to-picker"
    >
      <Select.Section>
        {/* DS Select.Section walks its children with React.Children.forEach
            and does not tolerate a mixed [ReactElement, ReactElement[]] child
            array — collect all options into a single flat array (mirrors the
            IIFE pattern in CheckerActionBar). */}
        {[
          <Select.Option key={ME_VALUE} value={ME_VALUE}>
            Me
          </Select.Option>,
          ...users.map((u) => (
            <Select.Option key={u.id} value={u.id}>
              {u.displayName}
            </Select.Option>
          )),
        ]}
      </Select.Section>
    </Select>
  );
};

export default AssignToPicker;
